export default "__VITE_ASSET__BaSF3gbY__"